module.exports = __webpack_public_path__ + "media/images/other/app-40dcd27c204ac6b70b300f8ee1bf81a9.jpg";